import React from "react";
import Moment from "moment";
// import "moment/locale/es";
import { toast } from "react-toastify";
import { safeFetch } from "../../../utils/security";
import Icon from "../Icon/Icon";
import "./CommBubble.scss";
import useGetBlobs from "@/services/utils/useGetBlobs";

interface ICommFile {
  sasUri: string;
  originalName: string;
  size?: number;
}

interface ICommMsg {
  asunto?: string;
  mensaje?: string;
  created?: string;
  autorUsuario?: boolean;
  nombreAutor?: string;
  files?: ICommFile[];
}

interface ICommBubbleProps {
  msg: ICommMsg;
  kind?: "warn" | "success" | "info" | "reply";
  isOriginal?: boolean;
}

const CommBubble: React.FC<ICommBubbleProps> = ({
  msg,
  kind = "info",
  isOriginal,
}) => {
  const { getDocumento, handleDownloadBlob } = useGetBlobs();

  const handleDownload = async (file: ICommFile) => {
    try {
      await handleDownloadBlob(file.sasUri, file.originalName);
    } catch {
      toast.error("No se pudo descargar el archivo.");
    }
  };

  const formatSize = (bytes?: number): string => {
    if (!bytes) return "";
    const kb = Math.round(bytes / 1024);
    return kb >= 1024 ? `${(kb / 1024).toFixed(1)} MB` : `${kb} KB`;
  };

  const hasFiles = msg.files && msg.files.length > 0;

  return (
    <div className={`comm-bubble comm-bubble--${kind}`}>
      <div className="comm-bubble__body">
        {isOriginal && msg.asunto && (
          <div className="comm-bubble__field">
            <span className="comm-bubble__label">Asunto</span>
            <div className="comm-bubble__subject">{msg.asunto}</div>
          </div>
        )}
        <div className="comm-bubble__field">
          <span className="comm-bubble__label">Mensaje</span>
          <div className="comm-bubble__msg">{msg.mensaje}</div>
        </div>
        {!isOriginal && msg.created && (
          <div className="comm-bubble__field">
            <span className="comm-bubble__label">Fecha</span>
            <span className="comm-bubble__meta">
              <Icon name="clock" size={12} />
              {Moment(msg.created).format("HH:mm")}h ·{" "}
              {Moment(msg.created).format("DD/MM/YYYY")}
            </span>
          </div>
        )}
      </div>

      {hasFiles && (
        <div className="comm-bubble__foot">
          <div className="comm-bubble__attach-label">
            <Icon name="paperclip" size={13} /> Documentos enviados
          </div>
          <div className="comm-bubble__attachs">
            {msg.files.map((f, i) => (
              <button
                key={i}
                type="button"
                className="comm-attach"
                onClick={() => handleDownload(f)}
              >
                <span className="comm-attach__icon">
                  <Icon name="file-text" size={15} />
                </span>
                <span className="comm-attach__info">
                  <span className="comm-attach__name">{f.originalName}</span>
                  {f.size && (
                    <span className="comm-attach__size">
                      {formatSize(f.size)}
                    </span>
                  )}
                </span>
                <Icon name="arrow-right" size={14} />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CommBubble;
